import React, { useContext, useEffect, useState, useRef } from 'react';
import StringField from 'Common/Components/StringField';
import { useDispatch } from 'react-redux';
import { Wrapper, Container, Title, Error, InputContainer } from './styled';
import { get, isEmpty } from 'lodash';
import { setFiedsError } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';
import { ThemeContext } from 'Context';
import { CVSS_TYPES, getCVSSType, CVSS_TYPES_LABELS, DEFAULT_CVSS_TYPE, hasCVSSValue, isWrong, parseCVSSEntry } from 'Screens/Contextualization/KnowledgeBase/components/VulnTemplateDetail/components/Tabs/components/GeneralTab/components/RiskInformation/components/CVSS/constants';
import Select from './Select';
import { setField } from 'Screens/Contextualization/KnowledgeBaseEditCreate/actions/Actions';

const getCVSSValue = (data, type) => {
  const vectorString = get(data, `${type}.vector_string`, '');
  if (!isEmpty(vectorString)) return vectorString;

  const baseScore = get(data, `${type}.base_score`, '');
  return hasCVSSValue(baseScore) ? String(baseScore) : '';
};

const CVSS = ({ data, onValidationChange }) => {
  const dispatch = useDispatch();
  const { themeStyles } = useContext(ThemeContext);
  const isFirstRun = useRef(true);
  const [type, setType] = useState(getCVSSType(data) || DEFAULT_CVSS_TYPE);
  const [vector, setVector] = useState(getCVSSValue(data, type));
  const [error, setError] = useState(isWrong(vector, type));

  const onChangeInput = (value) => {
    const parsedEntry = parseCVSSEntry(value, type);
    const nextError = isWrong(value, type);

    setVector(value);
    setError(nextError);
    onValidationChange(nextError);

    if (parsedEntry) dispatch(setField(type, parsedEntry));
    if (!hasCVSSValue(value)) dispatch(setField(type, { vector_string: '', base_score: '' }));
  };

  const onChangeSelect = (value) => {
    setVector('');
    setError(false);
    onValidationChange(false);
    setType(CVSS_TYPES[value]);
  };

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    const types = Object.values(CVSS_TYPES) || [];
    types.forEach((e) => {
      if (e !== type) {
        const value = getCVSSValue(data, e);
        if (!isEmpty(value)) {
          dispatch(setField(e, { vector_string: '', base_score: '' }));
          setVector('');
          setError(false);
          onValidationChange(false);
          dispatch(setFiedsError(false));
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  return (
      <Wrapper>
        <Title>CVSS Severity Score</Title>
        <Container>
            <Select theme={ themeStyles } updateValue={ (value) => onChangeSelect(value) } defaultValue={ CVSS_TYPES_LABELS[type] || '' } />
            <InputContainer>
              <StringField
                key={ type }
                error={ error }
                className="custom-background"
                width="100%"
                height="38px"
                name="cvss"
                defaultValue={ vector }
                onChange={ (value) => onChangeInput(value) }
                dataTestId="kb-cvss-input"
              />
            </InputContainer>
        </Container>
        {error && <Error>Invalid format</Error>}
      </Wrapper>
  );
};

export default CVSS;
